// Mock data for Sofia Russo Modeling Portfolio

export const modelData = {
  name: "Sofia Russo",
  tagline: "Professional Companion",
  heroTitle: "WHEN ONLY THE BEST WILL DO",
  heroSubtitle: "Experience the art of professional companionship",
  contact: {
    phone: "609-300-7180",
    email: "sofiarusso2020@protonmail.com"
  }
};

export const introData = {
  title: "THE ART OF PRESENCE",
  subtitle: "WHAT IS TIME WITH SOFIA RUSSO LIKE?",
  description: `Mature and articulate, I offer more than presence — I offer connection. Whether accompanying you to a formal event or sharing an intimate dinner, I bring warmth, discretion, and a refined energy that elevates every experience.`,
  quote: "Warmth, sophistication, and effortless chemistry.",
  image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/78m0rq9e_IMG_6298.jpeg"
};

export const aboutData = {
  title: "ABOUT SOFIA",
  background: {
    title: "BACKGROUND",
    content: `Educated, cultured, and effortlessly feminine, I am a woman who values both intellect and indulgence. With a graduate degree and fluency in multiple languages, I move comfortably through diverse social circles — from upscale dining rooms to international destinations.\n\nMy interests include global travel, luxury real estate, architecture, fine wines, and stimulating conversation. I appreciate depth, ambition, and men who have lived enough life to know exactly what they want.`
  },
  location: {
    title: "LOCATION",
    content: `Based in Florida, I travel often to the Northeast for select engagements.`
  },
  passions: {
    title: "PASSIONS",
    items: ["Travel", "Fine Wine", "Music", "Luxury Real Estate", "Film"]
  },
  image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/36w55hea_4594A%202.jpg"
};

export const galleryData = {
  title: "PORTFOLIO",
  subtitle: "Click on an image to view the full gallery",
  images: [
    {
      id: 1,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/78m0rq9e_IMG_6298.jpeg",
      category: "Boudoir"
    },
    {
      id: 2,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/peyghthf_ChatGPT%20Image%20Apr%205%2C%202026%2C%2007_19_38%20PM.png",
      category: "Glamour"
    },
    {
      id: 3,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/tfpgsvm1_E20AC6BD-5100-41DC-85EA-ED4E921178E2.jpeg",
      category: "Elegant"
    },
    {
      id: 4,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/dijyx5xi_IMG_6582.jpeg",
      category: "Lingerie"
    },
    {
      id: 5,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/0jfxzzd7_IMG_6769.jpeg",
      category: "Boudoir"
    },
    {
      id: 6,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/xczmrrw9_IMG_6581.jpeg",
      category: "Intimate"
    },
    {
      id: 7,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/2n8avypt_IMG_1565.JPG",
      category: "Lifestyle"
    },
    {
      id: 8,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/36w55hea_4594A%202.jpg",
      category: "Swimwear"
    },
    {
      id: 9,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/t8s792jn_IMG_8720.jpg",
      category: "Urban"
    },
    {
      id: 10,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/ovu9fw46_IMG_8836a.JPG",
      category: "Editorial"
    },
    {
      id: 10,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/va6amwok_4560b.jpg",
      category: "Fashion"
    },
    {
      id: 11,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/p7d5ubkk_IMG_9355ab.JPG",
      category: "Studio"
    },
    {
      id: 12,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/yoh3lz2y_IMG_9024a.JPG",
      category: "Sensual"
    },
    {
      id: 13,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/h35h83r1_IMG_9175b.JPG",
      category: "Artistic"
    },
    {
      id: 14,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/k2sd7uju_IMG_0654.JPG",
      category: "Classic"
    },
    {
      id: 15,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/g5tzh0q3_DSC_0099.jpg",
      category: "Glamour"
    },
    {
      id: 16,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/sm5lgmvx_IMG_9147a.JPG",
      category: "Lingerie"
    },
    {
      id: 17,
      src: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/853ls7qm_003.jpg",
      category: "Sheer"
    }
  ]
};

export const servicesData = {
  title: "SERVICES",
  subtitle: "Professional companionship tailored to your desires",
  packages: [
    {
      id: 1,
      title: "DINNER & DRINKS",
      description: "An elegant evening of fine dining and stimulating conversation",
      features: ["3-4 hours", "Upscale venues", "Sophisticated company"],
      rate: "2000",
      image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/ovu9fw46_IMG_8836a.JPG"
    },
    {
      id: 2,
      title: "MY FAVORITE",
      description: "An intimate experience — just me and you",
      features: ["2 hours", "Personal connection", "Undivided attention"],
      rate: "1400",
      image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/2n8avypt_IMG_1565.JPG"
    },
    {
      id: 3,
      title: "BRIEF BUT BEAUTIFUL",
      description: "A memorable encounter for those with limited time",
      features: ["1-1.5 hours", "Quality over quantity", "Lasting impression"],
      rate: "800 - 1200",
      image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/va6amwok_4560b.jpg"
    },
    {
      id: 4,
      title: "EXTENDED ENGAGEMENTS",
      description: "For those seeking more time together",
      features: ["Customized duration", "Travel companion", "Special occasions"],
      rate: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_model-showcase-94/artifacts/36w55hea_4594A%202.jpg"
    }
  ]
};

export const navigationLinks = [
  { id: "welcome", label: "WELCOME" },
  { id: "intro", label: "INTRO" },
  { id: "about", label: "ABOUT" },
  { id: "photos", label: "PHOTOS" },
  { id: "services", label: "SERVICES" },
  { id: "contact", label: "CONTACT" }
];
